import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import flow from 'lodash/fp/flow'
import set from 'lodash/fp/set'
import update from 'lodash/fp/update'
import pick from 'lodash/pick'

import {
    // Mount
    mountPageRequest,
    mountPageSuccess,
    mountPageFailure,
    unmountPageRequest,

    // Fetch data
    fetchPageDataRequest,
    fetchPageDataSuccess,
    fetchPageDataFailure,
} from 'actions/ui/shared/page'

import { SharedState } from './state'

// Cases added to the shared/index createReducer; state is parent UI state
export const addPageCases = (
    builder: ActionReducerMapBuilder<SharedState>
): void => {
    builder
        .addCase(mountPageRequest, (state, action) => {
            const {
                payload: { pageName, data },
            } = action
            return flow(
                set([pageName, 'mounting'], false),
                update([pageName], (pageState) => ({
                    ...pageState,
                    ...pick(data, ['resourceParams', 'dashboardParams']),
                }))
            )(state)
        })
        .addCase(mountPageSuccess, (state, action) => {
            const {
                payload: { pageName },
            } = action
            return set([pageName, 'mounting'], false)(state)
        })
        .addCase(unmountPageRequest, (state, action) => {
            const {
                payload: { pageName },
            } = action
            return flow(set([pageName, 'mounting'], true))(state)
        })
        .addCase(mountPageFailure, (state, action) => {
            const {
                payload: {
                    pageName,
                    data: { message },
                },
            } = action
            return flow(
                set([pageName, 'mounting'], false),
                set([pageName, 'error'], message)
            )(state)
        })
        .addCase(fetchPageDataRequest, (state, action) => {
            const {
                payload: { pageName },
            } = action
            return set([pageName, 'loading'], false)(state)
        })
        .addCase(fetchPageDataSuccess, (state, action) => {
            const {
                payload: { pageName },
            } = action
            return set([pageName, 'loading'], false)(state)
        })
        .addCase(fetchPageDataFailure, (state, action) => {
            const {
                payload: {
                    pageName,
                    data: { message },
                },
            } = action
            return flow(
                set([pageName, 'loading'], false),
                set([pageName, 'error'], message)
            )(state)
        })
}
